import { Component, inject, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FadingSpanComponent } from '../fading-span/fading-span.component';

@Component({
    selector: 'web-energy-info',
    templateUrl: './energy-info.component.html',
    styleUrls: ['./energy-info.component.scss'],
    imports: [FadingSpanComponent],
})
export class EnergyInfoComponent {
    protected sanitizer = inject(DomSanitizer);

    @Input()
    label?: string;
    @Input()
    color?: 'yellow' | 'blue' | 'grey' | 'green';
    @Input()
    value?: number;
    @Input()
    suffix?: string;
    @Input()
    hideValue?: boolean;
    @Input()
    autorizeZero?: boolean;

    @Input()
    labelOneLine?: boolean = true;

    @Input()
    valueClass = 'number-regular';
    @Input()
    suffixClass = 'grey sub-headline-bold';

    @Input()
    icon? = false;
}
